<!-- <div class="row"> -->

    <!-- <div class="col-12"> -->
        <div class="title">
            <div class="logo">
                <img src="/assets/images/articool.svg" alt="{{ 'COMPANY.LOGO' | translate }}">
            </div>
            <div class="text">
                {{ 'COMPANY.NAME' | translate }}
            </div>
        </div>
    <!-- </div> -->

    <!-- <div class="col-12"> -->
        <div class="btn-tabs">
            <div class="login"  [ngClass]="{'active': path == 'login'}" routerLink="/login">{{ 'MENU_UNAUTH_USER.LOGIN' | translate }}</div>
            <div class="logout" [ngClass]="{'active': path == 'registration'}" routerLink="/registration">{{ 'MENU_UNAUTH_USER.REGISTRATION' | translate }}</div>
        </div>
    <!-- </div> -->

<!-- </div> -->